import * as React from "react";
const SvgGithub = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#Github_svg__a)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "#F7F7F7",
  rx: 6
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M12 1.841c5.474 0 9.917 4.468 9.997 10.01l.003.22c-.031 4.694-3.192 8.63-7.469 9.764a.6.6 0 0 1-.032-.184c0-.352.014-1.472.014-2.866 0-.976-.313-1.602-.675-1.928 2.225-.26 4.562-1.146 4.562-5.144 0-1.145-.386-2.07-1.024-2.8.1-.26.45-1.329-.1-2.761-.023-.007-.864-.268-2.751 1.068a9 9 0 0 0-2.5-.352c-.85 0-1.7.118-2.5.352-1.888-1.323-2.729-1.075-2.751-1.068-.55 1.432-.201 2.5-.101 2.761-.637.73-1.024 1.668-1.024 2.8 0 3.985 2.325 4.884 4.55 5.144-.287.26-.55.717-.638 1.394-.575.273-2.013.717-2.913-.859-.188-.313-.75-1.081-1.538-1.068-.837.013-.337.494.013.69.426.248.913 1.172 1.026 1.472.2.586.85 1.705 3.363 1.223 0 .873.013 1.694.013 1.942a.6.6 0 0 1-.035.19C5.194 20.713 2.02 16.761 2 12.05v-.117c.037-5.58 4.5-10.09 10-10.09"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "Github_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
}))));
export default SvgGithub;
//# sourceMappingURL=Github.js.map